module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/bologna.2a4415243b447c55b95c379878e67015.jpg";